import { render, staticRenderFns } from "./MaterialesForm.vue?vue&type=template&id=32f53437"
import script from "./MaterialesForm.vue?vue&type=script&lang=js"
export * from "./MaterialesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports